import React from "react";
import PropsTypes from "prop-types";
import Button from "./Button";
import { BUTTON_CONFIG } from "config/constants/Button";

function ConfirmationModal({
  show: bShow = false,
  onClose = () => {},
  onConfirm = () => {},
  message: sMessage = null,
  title: sTitle = "Confirmación",
  noQuestion: bNoQuestion = false,
  labelConfirm: sLabelConfirm = "Aceptar",
  question: sQuestion = "Seguro que quiere realizar esta acción",
}) {

  return (
    bShow && <>
      <div className="fixed top-0 right-0 h-screen w-screen z-[51] bg-gray-900 opacity-40" />
      <div className="fixed z-[52] top-0 right-0 h-screen w-screen flex items-center justify-center p-4" onClick={onClose} >
        <div className="rounded-lg border border-line dark:border-line-dark shadow-xl overflow-hidden max-w-xs md:max-w-md" onClick={oEvent => oEvent.stopPropagation()} >
          <div className="px-4 py-3 bg-white dark:bg-gray-800 border-b border-line dark:border-line-dark">
            <span className="text-sm font-medium text-gray-800 dark:text-white">{sTitle}</span>
          </div>
          <div className="bg-white text-gray-700 dark:bg-gray-800 dark:text-gray-300 p-4">
            {!bNoQuestion && <p className="text-center">¿{sQuestion}?</p>}
            {
              sMessage
              && <p className={`${bNoQuestion ? "text-xs mt-5" : "text-sm"} text-center md:text-left`}>
                {sMessage}
              </p>
            }
            <div className="mt-5 flex justify-end gap-2">
              <Button
                onClick={onClose}
                type={BUTTON_CONFIG.CLASS.SUCCESS}
                size={BUTTON_CONFIG.SIZE.SM}
                label="Cancelar"
              />
              <Button
                onClick={onConfirm}
                type={BUTTON_CONFIG.CLASS.PRIMARY}
                size={BUTTON_CONFIG.SIZE.SM}
                label={sLabelConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ConfirmationModal.propTypes = {
  show: PropsTypes.bool.isRequired,
  title: PropsTypes.string,
  question: PropsTypes.string,
  message: PropsTypes.string,
  onConfirm: PropsTypes.func.isRequired,
  onClose: PropsTypes.func.isRequired,
};

export default ConfirmationModal;
